import { LoginAction } from '../types/LoginAction';
import { userService } from '../services/userService';
import { User } from '../types/UserData';
import ACLService from '../../acl/services/aclService';
import { LoginRequest } from '../types/LoginRequest';
import { ServerAlertAction } from '../../common';
import config from '../../../config/config';

const login = (loginRequest: LoginRequest, isTeacherLogin: boolean = false) => (dispatch: any) => {
    const success = (res: User): LoginAction => {
        if (!res.roles || res.roles.length == 0) {
            res.roles = [];
            res.roles.push({ 'roleId': res.role })
        }
        return {
            type: 'LOGIN_SUCCESS', data: {
                isAuthenticated: true,
                authenticatedUser: res,
                selectedRoleIndex: 0,
                selectedRole: (res.roles.length == 1 ? true : false),//if only one role is assigned no need to show role selection screen
            }
        }
    }
    const failure = (): LoginAction => {
        return { type: 'LOGIN_FAILED', data: { isAuthenticated: false } }
    }

    const licenseExpired = (): LoginAction => {
        return { type: 'LICENSE_EXPIRED' }
    }

    const loggedInUserData = (data: any) => {
        return { type: 'LOGGED_IN_USER', data: data}
    }

    if (isTeacherLogin) {
        userService.teacherLogin()
            .then(
                (res) => {
                    switch (res.statusCode) {
                        case 200:
                            dispatch(success(res.responseObject));
                            dispatch(loggedInUserData(res.responseObject.clientId.license));
                            break;
                        case 433:
                            dispatch(licenseExpired());
                            break;
                        default:
                            localStorage.removeItem(config.localStorageKey);
                    }
                },
                (error: any) => {
                    dispatch(failure())
                }
            );
    } else {
        userService.login(loginRequest)
            .then(
                (res) => {
                    
                    switch(res.statusCode){
                        case 200:
                            dispatch(success(res.responseObject));
                            
                            dispatch(loggedInUserData(res.responseObject.clientId.license));
    
                            break;
                        case 433:
                            dispatch(licenseExpired());
                            break;
                        default:
                    }
                },
                (error: any) => {
                    
                    dispatch(failure())
                }
            );
    }
}

export const setLoggedInUser = () => {
    return {
        type: 'LOGGED_IN_USER'
    }
}


export const toggleLicenseExpiredDialog = (data: boolean) => {
    return {
        type: 'TOGGLE_LICENSE_EXPIRY_DIALOG',
        data
    }
}

const forgotPassword = (email:any,host:any) => (dispatch: any) => {
    const success = (res: any): any => {
        return {
            type: 'MAIL_SENT_SUCCESS', data: {
                
            }
        }
    }
    const failure = (): any => {
        return {
            type: 'MAIL_SENT_FAILURE', data: {
                
            }
        }
    }

    userService.forgotPassword(email,host)
        .then(
            (res) => {

                dispatch(success(res))
            },
            (error: any) => {
                dispatch(failure())
            }
        );
}


const setSelectedRole = (index: number): LoginAction => {
    return { type: 'ROLE_SELECTED', data: { selectedRoleIndex: index, selectedRole: true } }
}

const logout = (): any => {

    return {
        type: 'LOGOUT_SUCCESS', data: {
            isAuthenticated: false,
            authenticatedUser: null,
            selectedRoleIndex: 0,
            selectedRole: false,
        }
    }
}

const switchRole = (index: number) => {
    ACLService.switchRole(index);
    return { type: 'SWITCH_ROLE', data: { selectedRoleIndex: index } }
}


const userActions = {
    login,
    logout,
    setSelectedRole,
    switchRole,
    forgotPassword
};
export default userActions;